import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import PrivateInvestigationIndustry from "@/pages/industries/PrivateInvestigationIndustry";
export const Route = createFileRoute("/industries/private-investigation")({ head: ({match}) => pageHead(match.pathname), component: () => (<PrivateInvestigationIndustry />) });
